import React from 'react'
import TableCellMobile from './TableCellMobile'
import TableCellDesktop from './TableCellDesktop'

const TableCellHeures = ({
  item,
  label,
  device
}) => {
  const value = parseFloat(item.heures)
  const object = {
    value: value,
    empty: (value === 0)
  }
  return (device.mobile)
    ? <TableCellMobile
        label={label}
        {...object}
      />
    : <TableCellDesktop
        max={75}
        {...object}
      />
}

export default TableCellHeures
